import { type OfferV11 } from '@redteclab/api/clients/bully'

import { productAccessorSellerPromotionExistsForOtherSeller } from './productAccessorSellerPromotionExistsForOtherSeller'

export const productAccessorProductHasSellerPromotionOnDifferentOffer = (
  currentOffer: OfferV11 | undefined,
  allOffers: OfferV11[] | undefined,
): boolean =>
  currentOffer?.seller !== undefined &&
  productAccessorSellerPromotionExistsForOtherSeller(
    currentOffer.seller.sellerId,
    allOffers,
  )
